import * as React from 'react';
import { Navigation } from 'utils/Navigation';

export class TabHeader extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.handleItemClick = this.handleItemClick.bind(this);
    }

    private handleItemClick(url: string) {
        Navigation.pushState({}, url);
    }

    public render() {
        return (
            <div style={{ width: '100%', height: this.props.height, backgroundColor: this.props.bgColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {this.props.items.map((item, index) => {
                    return (
                        <div
                            key={"ti-" + index}
                            onClick={() => {
                                if (item.selected) {
                                    return;
                                }
                                this.handleItemClick(item.url);
                            }}
                            style={{
                                fontSize: this.props.fontSize,
                                fontWeight: item.selected ? 900 : 400,
                                color: item.selected ? '#fff' : 'rgba(255,255,255, 0.9)',
                                textDecoration: item.selected ? 'underline' : 'none',
                                cursor: 'pointer',
                                paddingLeft: '20px',
                                paddingRight: '20px',
                            }}
                        >
                            {item.title}
                        </div>
                    )
                })}
            </div>
        )
    }

}

export interface Props {

    height: string;
    bgColor: string;
    fontSize: string;
    items: TabItem[];

}

export interface TabItem {

    title: string;
    url: string;
    selected: boolean;

}

interface State {

}